import {
  ENUM_LABELS,
  REPORT_STATUS_TABS,
  type ReportStatus,
  type WorklistPage,
} from '#shared/types';

interface StatusTab {
  value: (typeof REPORT_STATUS_TABS)[number];
  label: string;
  count: number | undefined;
  pip: boolean;
}

/** One tab per status, with its count and the overdue pip. */
export function buildStatusTabs(page: WorklistPage | undefined): StatusTab[] {
  const overdueCount = page?.overdue_count ?? 0;
  return REPORT_STATUS_TABS.map((status) => ({
    value: status,
    label: ENUM_LABELS.reportStatus[status],
    count: page?.status_counts[status],
    // Completed work cannot be overdue, so the pip only belongs on open tabs.
    pip: status !== 'completed' && overdueCount > 0,
  }));
}

/*
 * Empty states are per tab and phrased as good news, because on these tabs an
 * empty list usually is good news. "No records found" would read as a failure.
 */
export function emptyTitle(status: ReportStatus): string {
  if (status === 'in_progress') return 'Nothing in progress';
  if (status === 'completed') return 'Nothing completed yet';
  return 'Nothing waiting to be started';
}

export function emptyBody(status: ReportStatus): string {
  if (status === 'completed') return 'Completed reports will collect here.';
  return 'New registrations will appear here as they come in.';
}
